export const ADD_TO_CART_COUNT_SESSION_DATA_KEY = 'add_to_cart_count';
